import React from 'react';
import { Form, Input, Button, Typography } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { useAppDispatch } from 'hooks/useStore';
import IconSVG from 'assets/images/5.svg';
import { login } from 'features/User/UserSlice';
import { KeyOutlined, MailOutlined } from '@ant-design/icons';

import * as S from './Login.styled';
import { unwrapResult } from '@reduxjs/toolkit';
import Meta from 'components/Meta';

const { Title, Text } = Typography;

const Login: React.FC = () => {
	const dispatch = useAppDispatch();
	const { push } = useHistory();

	const onHandleLogin = ({ email, password }: { email: string; password: string }) =>
		dispatch(login({ email, password }))
			.then(unwrapResult)
			.then(() => push('/'))
			.catch(console.error);

	const onError = () => alert('Invalid user!');

	return (
		<>
			<Meta pageName="login" />
			<S.Login>
				<S.Form>
					<Form
						name="basic"
						labelCol={{ span: 0 }}
						wrapperCol={{ span: 24 }}
						style={{ borderRadius: '3px' }}
						initialValues={{
							email: '',
							password: '',
						}}
						onFinish={onHandleLogin}
						onFinishFailed={onError}
						autoComplete="off"
						className="form">
						<S.Head>
							<img
								src={IconSVG}
								alt="SMART PROPERTY UAE"
								style={{
									maxHeight: 144,
									marginBottom: 20,
									borderRadius: 32,
								}}
							/>
							<Title level={5} style={{ marginBottom: '4px' }}>
								SMART PROPERTY UAE
							</Title>
							<Text type="secondary">Managment platform or property application</Text>
						</S.Head>
						<Form.Item
							name="email"
							style={{ marginBottom: 14 }}
							rules={[{ required: true, message: 'Please input your email!' }]}>
							<Input
								placeholder="Email"
								prefix={<MailOutlined style={{ marginRight: 4, color: '#B7B7B7' }} />}
								autoComplete="off"
							/>
						</Form.Item>
						<Form.Item
							name="password"
							rules={[{ required: true, message: 'Please input your password' }]}
							style={{ marginBottom: 14 }}>
							<Input.Password
								placeholder="Password"
								prefix={<KeyOutlined style={{ marginRight: 4, color: '#B7B7B7' }} />}
								autoComplete="off"
							/>
						</Form.Item>
						<Form.Item wrapperCol={{ offset: 0, span: 24 }} style={{ marginBottom: 14 }}>
							<Button type="primary" htmlType="submit" style={{ width: '100%' }}>
								Log in
							</Button>
						</Form.Item>
						<Form.Item wrapperCol={{ offset: 0, span: 24 }} style={{ marginBottom: 0 }}>
							<Link to="/register">
								<Button style={{ width: '100%' }} htmlType="button">
									Sign up
								</Button>
							</Link>
						</Form.Item>
						<Form.Item wrapperCol={{ offset: 0, span: 24 }} style={{ marginBottom: 0 }}>
							<S.Policy>
								By signing up I agree to the{' '}
								<a
									href="http://realty-uae.maksimzaycev.ru/privacy"
									target="_blank"
									rel="noreferrer">
									Privacy Policy
								</a>
							</S.Policy>
						</Form.Item>
					</Form>
				</S.Form>
			</S.Login>
		</>
	);
};

export default Login;
